import { render } from "./IconWiper.vue?vue&type=template&id=cff748ce&lang=pug&bindings={\"id\":\"props\"}"
import script from "./IconWiper.vue?vue&type=script&lang=js"
export * from "./IconWiper.vue?vue&type=script&lang=js"
script.render = render

export default script